/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ShopList_landingPage$ref = any;
export type ShopList_landingPage = {
    readonly list: {
        readonly title: string | null;
        readonly listGroups: ReadonlyArray<{
            readonly title: string | null;
            readonly listItems: ReadonlyArray<{
                readonly imageUrl: string | null;
                readonly title: string | null;
                readonly url: string | null;
            } | null> | null;
        } | null> | null;
    } | null;
    readonly " $refType": ShopList_landingPage$ref;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "ShopList_landingPage",
  "type": "LandingPage",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "list",
      "storageKey": null,
      "args": null,
      "concreteType": "LandingPageList",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "listGroups",
          "storageKey": null,
          "args": null,
          "concreteType": "LandingPageListGroup",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "listItems",
              "storageKey": null,
              "args": null,
              "concreteType": "LandingPageListItem",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "imageUrl",
                  "args": null,
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "url",
                  "args": null,
                  "storageKey": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
(node as any).hash = 'db499c6d7e5021dffcb2168929c4f77b';
export default node;
